module.exports = __webpack_public_path__ + "media/images/authentication/authentication-bg-9491e81951d8b5615a19e62774be0708.svg";